import React, { useState, useEffect } from "react";
import {
	useGetDomainGymQuery,
	useCheckCustomerPaymentMethodQuery,
	useStripeCheckSubscriptionStatusMutation,
} from "store/api/api";
import { useRecoilValue } from "recoil";
import { userAtom } from "../../globalAtoms";
import { useParams } from "react-router";
import { Button, Flex, Typography } from "antd";
import { WarningOutlined } from "@ant-design/icons";
import "./styles.scss";
import MemberSubscriptionModal from "components/Modals/MemberSubscriptionModal";
import dayjs from "dayjs";

const StripeSubscriptionAlerts = () => {
	const { gym } = useParams();
	const user = useRecoilValue(userAtom);
	const domainGymResponse = useGetDomainGymQuery(gym);
	const gymData = domainGymResponse?.data;
	const [open, setOpen] = useState(false);
	const [checkSubscriptionStatusTrigger, subscriptionStatus] = useStripeCheckSubscriptionStatusMutation({});
	const { data } = useCheckCustomerPaymentMethodQuery(
		{ userId: user?.id, gymId: gymData?.id },
		{ skip: !user || !gymData?.id }
	);

	const userAssociations = user?.userAssociations;
	const associationInUse = userAssociations?.find((a) => a.gym_id === gymData?.id) || {};
	const { subscription_id, subscription_status: status } = associationInUse;

	useEffect(() => {
		if (status !== "TRIAL") {
			if (user?.customer_id && gymData?.id) {
				checkSubscriptionStatusTrigger({ subscription_id });
			}
		}
	}, [user, gymData, checkSubscriptionStatusTrigger, subscription_id, status]);

	if (data?.is_platform_subscription || data?.is_pm_valid) return null;

	const subscriptionEndDate = subscriptionStatus?.data?.current_period_end
		? dayjs(subscriptionStatus?.data?.current_period_end * 1000)
		: dayjs(associationInUse?.subscription_start_date * 1000).add(1, "month");

	const gracePeriodEndDate = subscriptionEndDate.add(21, "day");

	const isExpired = subscriptionEndDate.isBefore(dayjs()) || status === "EXPIRED";
	const message = gracePeriodEndDate.isBefore(dayjs())
		? `Your account is past due and expired on ${gracePeriodEndDate?.format(
				"YYYY-MM-DD"
		  )}. Please update your payment method to reactivate.`
		: `Your account is past due and will expire on ${gracePeriodEndDate?.format(
				"YYYY-MM-DD"
		  )}. Please update your payment method to continue.`;
	const subscriptionStatusMessage = "Update Payment Method";

	if (!isExpired || status === "TRIAL" || subscriptionStatus?.isLoading) {
		return null;
	}
	return (
		<Flex justify="space-between" className="subscription-alerts">
			<Flex gap={8} align="center">
				<WarningOutlined />
				{message}
			</Flex>
			<Button onClick={() => setOpen(true)} color="primary" variant="solid">
				<Typography.Text style={{ fontSize: 12, color: "#fff" }}>{subscriptionStatusMessage}</Typography.Text>
			</Button>
			<MemberSubscriptionModal
				open={open}
				onClose={() => setOpen(false)}
				afterSubscribe={() => window.location.reload()}
				gymId={gymData?.id}
				customerId={user?.customer_id}
				gymName={gymData?.name}
			/>
		</Flex>
	);
};

export default StripeSubscriptionAlerts;

